import React, { Fragment, useState, useLayoutEffect, useContext } from "react";
import { Col } from "reactstrap";
import { AlignCenter, Grid, AlignJustify } from "react-feather";
import { Link } from "react-router-dom";
import { H6, Image } from "../../../AbstractElements";
import CustomizerContext from "../../../_helper/Customizer";
import NotificationSlider from "./NotificationSlider";
import PromiseSpinner from '../../../CommonElements/Spinner/PromiseSpinner'; 

const Leftbar = () => {
  const { setToggleIcon,toggleIcon, toggleSidebar } = useContext(CustomizerContext);
  const [sidebartoggle, setSidebartoggle] = useState(true);
  const width = useWindowSize();

  const openCloseSidebar = () => {
    toggleSidebar(!toggleIcon);
  };

  function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);       

        if (window.innerWidth <= 991) {
        setToggleIcon(true);
        
        } else {
          setToggleIcon(false);
        }
      }
      window.addEventListener("resize", updateSize);
      updateSize();
      return () => window.removeEventListener("resize", updateSize);
    }, []);
    return size;
  }

  const responsive_openCloseSidebar = (toggle) => {
    if (width <= 991) {
      toggleSidebar(!toggle);
      document.querySelector(".sidebar-wrapper").className = "sidebar-wrapper ";
      document.querySelector(".bg-overlay1").classList.add("active");
    } else {
      if (toggle) {
       toggleSidebar(!toggle);
        document.querySelector(".sidebar-wrapper").className = "sidebar-wrapper close_icon ";
      } else {
        console.log("991 54 else", toggle);
        toggleSidebar(!toggle);
        document.querySelector(".sidebar-wrapper").className = "sidebar-wrapper ";
      }
    }
  };

  return ( 
    <Fragment>
      <Col  className="header-logo-wrapper col-auto p-0" id="out_side_click">

    
      <div onClick={() => openCloseSidebar()} style={{position:"relative", top:7}}>
        <AlignJustify className="status_toggle middle sidebar-toggle" id="sidebar-toggle" />
      </div>
      

      {/*

<div className="logo-wrapper">
          <Link to={`${process.env.PUBLIC_URL}/dpsm/home`}>
            <Image
              attrImage={{
                className: "img-fluid for-light",
                src: `${require("../../../assets/images/logo/logo.png")}`,
                alt: "",
              }}
            />
            <Image
              attrImage={{
                className: "img-fluid for-dark",
                src: `${require("../../../assets/images/logo/logo_dark.png")}`,
                alt: "",
              }}
            />
          </Link>
        </div>
        <div className="toggle-sidebar" onClick={() => responsive_openCloseSidebar(sidebartoggle)} style={window.innerWidth <= 991 ? { display: "block" } : { display: "block" }}>
          <AlignCenter className="status_toggle middle sidebar-toggle" id="sidebar-toggle" />
Hello
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="status_toggle middle sidebar-toggle" id="sidebar-toggle"><line x1="18" y1="10" x2="6" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="18" y1="18" x2="6" y2="18"></line></svg>
        
        </div>
*/}

      </Col>
      
      
      <Col xxl="2" xl="3" lg="4" md="5" sm="5" className="col-auto p-0">
        <PromiseSpinner /> 
      </Col>

    </Fragment>
  );
};

export default Leftbar;
